import { createFileRoute } from "@tanstack/react-router";
import { SeleccionarOrdenDeCompraPage } from "@/features/seleccionar-orden-compra/components/SeleccionarOrdenDeCompraPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/orden-compra` · paso previo al CFDI del tipo Orden de
 * Compra. Loader precarga la solicitud.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/orden-compra")({
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: SeleccionarOrdenDeCompraPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
